import { buildAffiliatesQuery } from '../utils/query';

// TODO: se harcodean los parametros path
const projectId = 'motorplay_unified';

export const getInitiateBindingSecuredUrlRequest = buildAffiliatesQuery(
  state => ({
    url: `/processes/${projectId}/${state.cp}/binding/secure-url/${state.userDeviceToken}`,
    transform: ({ securedUrl: initiateBindingSecuredUrl }) => {
      return { initiateBindingSecuredUrl };
    },
    update: {
      initiateBindingSecuredUrl: (pre, updated) => updated,
    },
  })
);

export const getBindingRequest = buildAffiliatesQuery(state => ({
  url: `/bindings/${projectId}/${state.cp}/device/${state.userDeviceToken}`,
  transform: ({ binding, boundSubscriberUser, subscriptionActionConfigs }) => {
    return { binding, boundSubscriberUser, subscriptionActionConfigs };
  },
  update: {
    binding: (prev, updated) => updated,
    boundSubscriberUser: (prev, updated) => updated,
    subscriptionActionConfigs: (prev, updated) => updated,
  },
}));

export const getSubscriberRequest = buildAffiliatesQuery(state => ({
  url: `/subscribers/device/${state.userDeviceToken}?${new URLSearchParams({
    cp: state.cp,
    projectId,
  }).toString()}`,
  transform: ({ subscriber } = {}) => ({ subscriber }),
  update: {
    subscriber: (prev, updated) => updated,
  },
}));

export const unbindSubscriberMutation = buildAffiliatesQuery(
  ({ client, cp, userDeviceToken }) => {
    const searchParams = new URLSearchParams({
      account_manager_device_token: userDeviceToken,
      account_manager_idp: client,
    });

    return {
      url: `/processes/${projectId}/${cp}/binding?${searchParams.toString()}`,
      options: {
        method: 'DELETE',
      },
      transform: ({ binding }) => {
        return { binding };
      },
      update: {
        binding: (prev, updated) => updated,
        subscriptions: subs => ({ ...subs, activePlan: null }),
      },
    };
  }
);

export const getDevices = buildAffiliatesQuery(({ cp, customerId }) => ({
  url: `/devices/${projectId}/${cp}/${customerId}`,
  transform: devices => {
    return { devices };
  },
  update: {
    devices: (_prev, updated) => updated,
  },
}));

export const deleteDevice = ({ deviceToken, cp, customerId, serviceConfig, return_url }) => ({
  url: `${serviceConfig.affiliates.baseURL}/devices/${projectId}/${cp}/_deviceManager/${customerId}?${new URLSearchParams({
    devices: deviceToken,
    return_url,
  }).toString()}`,
  options: { method: 'GET' },
  transform: () => {
    window.location.href = return_url; // return url already contains the token.
  },
  update: {
    devices: (oldDevices, updated) => oldDevices.filter((device) => !deviceToken.split('|').includes(device.token)),
  },
});
